import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Button, Tag } from "antd";
import React from "react";
import { FlightOpenIcon } from "~/components/flight/flightOpenIcon.jsx";
import { $t } from "~/i18n.js";
import { _parseDate } from "~/lib/localize.js";
import { PaymentTag } from "./PaymentTag.jsx";
import { RenderLedgerAmount } from "./RenderLedgerAmount.jsx";

export function LedgerColumns({ onEdit, hasUsers, ledgerImportStatus }) {
  return [
    {
      title: $t("Datum"),
      dataIndex: "date_created",
      render: (value) => _parseDate(value),
    },
    hasUsers
      ? {
          title: $t("Intern/Extern"),
          render: (_, record) => {
            // Vouchers are extern=al
            const isExtern = record.voucher;
            return (
              <Tag color={isExtern ? undefined : "blue"}>
                {isExtern ? $t("Extern") : $t("Intern")}
              </Tag>
            );
          },
        }
      : null,

    hasUsers
      ? {
          title: $t("Gebruiker"),
          render: (_, record) =>
            record.user ? record.user.name : record.voucher?.name,
        }
      : null,
    {
      title: $t("Omschrijving"),
      dataIndex: "name",
      render: (value, record) => (
        <div>
          {value}

          {record.payment_status && $t("Online betaling")}

          {record.flight_id && (
            <FlightOpenIcon flight_uuid={record.flight_id} />
          )}
        </div>
      ),
    },
    {
      title: $t("Betaling"),
      render: (value, record) => (
        <div>
          {record.error && (
            <Tag color="red" style={{ marginRight: 8 }}>
              {$t("Data fout")}
            </Tag>
          )}
          {record.payment_status && (
            <PaymentTag status={record.payment_status} />
          )}
          {!record.error && record.is_custom && (
            <Tag color="blue" style={{ marginRight: 8 }}>
              {$t("Handmatig")}
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: <div style={{ marginRight: 6 }}>{$t("Bedrag")}</div>,
      dataIndex: "amount",
      align: "right",
      render: (_, record) => <RenderLedgerAmount ledger={record} />,
    },
    onEdit && {
      render: (_, record) =>
        !record.payment_status && (
          <Button size="small" onClick={() => onEdit(record)}>
            {$t("Bewerken")}
          </Button>
        ),
    },

    ledgerImportStatus
      ? {
          title: $t("Status"),
          width: 120,
          render: (_, record) => {
            const status = ledgerImportStatus[record.id];
            return (
              <div>
                {status === "skipped" && (
                  <Tag color="orange">{$t("Overgeslagen")}</Tag>
                )}
                {status === "loading" && (
                  <Tag icon={<SyncOutlined spin />} color="processing" />
                )}
                {status === "success" && (
                  <Tag icon={<CheckCircleOutlined />} color="success" />
                )}
                {status?.startsWith("fail") && (
                  <Tag icon={<ExclamationCircleOutlined />} color="warning">
                    {status}
                  </Tag>
                )}
              </div>
            );
          },
        }
      : null,
  ].filter((f) => f);
}
